export default __webpack_public_path__ + "static/media/Kanit-Regular.6a45a65e.ttf";